module.exports = __webpack_public_path__ + "202408221624/img/img_upload_work_120@2x.53bff971.png";